import React from 'react'
// import SidebarEmployees from '../SidebarEmployees/SidebarEmployees'
import { Route, Routes } from 'react-router-dom';
import "../Header/Header.css"
import EmpTeamAdmin from '../EmpTeamAdmin/EmpTeamAdmin';
import AllCurrentStaff from '../AllCurrentStaff/AllCurrentStaff';
import DeactivatedStaff from '../AllCurrentStaff/DeactivatedStaff';
import EmpStreamAccess from '../EmpStreamAccess/EmpStreamAccess';
import AddStaff from '../AddStaff/AddStaff';
import AddContractor from '../AddContractor/AddContractor';
import ApproveChanges from '../ApproveChanges/ApproveChanges';
import EditStaffInfo from '../EditStaffInfo/EditStaffInfo';
function Employees() {
  return (
    <div className='flex layout'>
    <aside id='aside-sidebar'>
      {/* <SidebarEmployees /> */}
    </aside>
    <div className='content' id='main-content'>
      <Routes>
        <Route exact path="/" element={<EmpTeamAdmin />} />
        <Route exact path="/allcurrentstaff" element={<AllCurrentStaff />} />
        <Route exact path="/deactivated" element={<DeactivatedStaff />} />
        <Route exact path="/empstreamaccess" element={<EmpStreamAccess />} />
        <Route exact path="/addstaff" element={<AddStaff />} />
        <Route exact path="/addcontractor" element={<AddContractor />} />
        <Route exact path="/approvechanges" element={<ApproveChanges />} />
        <Route exact path="/editstaffinfo" element={<EditStaffInfo />} />
      </Routes>
    </div>
  </div>
  )
}

export default Employees